import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import { errorKeyMap } from "../../../../models/TicketProcessingParams/ticketProcessing.model";
import { disableFutureDates } from "../../../../utils/disabledDateUtil";

export const processingInputsConstants = {
  SUBMIT_BTN_TXT: "Submit",
  MANAGER_REVIEW_BTN_TXT: "Manager Review",
  SUBMIT_BTN_CLASS: "submitBtnStyle",
  MANAGER_REVIEW_BTN_CLASS: "managerReviewBtnStyle",
  DATE_PICKER_SIZE: "large",
  ROW_ALIGN: "middle",
  ROW_JUSTIFY: "space-between",
  REPLACE_TKT_BTN_TEXT: "Replace Ticket",
  APPROVE_TKT_BTN_TEXT: "Approve",
  TIME_PICKER_CLASS: "timePickerField",
  VIEW_ORIGINAL_TICKET: "View Original Ticket",
};

export const fieldConstants = {
  SIGNED_BY_NAME: "signedByCustomer",
  SIGNED_BY_LABEL: "Signed by Customer",
  DAILY_SUMMARY_NAME: "dailySummary",
  DAILY_SUMMARY_LABEL: "Daily Summary",
  TICKET_DATE_LABEL: "Ticket Date",
  TICKET_DATE_NAME: "ticketDate",
  TICKET_NUMBER_LABEL: "Ticket Number",
  TICKET_NUMBER_NAME: "ticketNumber",
  TRUCK_NUMBER_LABEL: "Truck Number",
  TRUCK_NUMBER_NAME: "truckNumber",
  QUANTITY_LABEL: "Quantity",
  QUANTITY_NAME: "quantity",
  START_TIME_LABEL: "Start Time",
  START_TIME_NAME: "startTime",
  END_TIME_LABEL: "End Time",
  END_TIME_NAME: "endTime",
  LOAD_TIME_LABEL: "Load Time",
  LOAD_TIME_NAME: "loadTime",
  LOAD_COUNT_LABEL: "Load Count",
  LOAD_COUNT_NAME: "loadCount",
  REVIEW_NOTES_NAME: "reviewNotes",
  REVIEW_NOTES_LABEL: "Review Notes",
};

export const placeholderValues = {
  DATE_PLACEHOLDER: "mm/dd/yyyy",
  SELECT_PLACEHOLDER: "Select",
  TIME_PLACEHOLDER: "HH:MM A",
  QUANTITY_PLACEHOLDER: "Enter qty",
  NUMBER_PLACEHOLDER: "Enter number",
  COUNT_PLACEHOLDER: "Enter count",
};

export const checkboxFields = [
  {
    type: InputfieldTypes.CHECKBOX,
    name: fieldConstants.SIGNED_BY_NAME,
    label: fieldConstants.SIGNED_BY_LABEL,
  },
  {
    type: InputfieldTypes.CHECKBOX,
    name: fieldConstants.DAILY_SUMMARY_NAME,
    label: fieldConstants.DAILY_SUMMARY_LABEL,
  },
];

export const getInputFields = (
  dailySummaryChecked?: boolean,
  isManagerReview?: boolean,
  isSubmitted?: boolean,
  errorKeys?: errorKeyMap | {},
) => [
  {
    type: InputfieldTypes.DATE_PICKER,
    name: fieldConstants.TICKET_DATE_NAME,
    label: fieldConstants.TICKET_DATE_LABEL,
    datepickerSize: processingInputsConstants.DATE_PICKER_SIZE,
    placeholder: placeholderValues.DATE_PLACEHOLDER,
    visible: true,
    disabledDates: disableFutureDates,
    span: 7,
    fieldAlert: isSubmitted ? false : errorKeys?.ticketDate,
    allowDateClear: true,
    disabled: isSubmitted,
    allowTyping: true,
  },
  {
    type: InputfieldTypes.TEXT,
    name: fieldConstants.TICKET_NUMBER_NAME,
    label: fieldConstants.TICKET_NUMBER_LABEL,
    placeholder: placeholderValues.NUMBER_PLACEHOLDER,
    visible: true,
    span: 7,
    fieldAlert: isSubmitted ? false : errorKeys?.ticketNumber,
    allowClear: true,
    disabled: isSubmitted,
    maxTextLength: 30,
  },
  {
    type: InputfieldTypes.TIME_PICKER,
    name: fieldConstants.START_TIME_NAME,
    label: fieldConstants.START_TIME_LABEL,
    className: processingInputsConstants.TIME_PICKER_CLASS,
    placeholder: placeholderValues.TIME_PLACEHOLDER,
    visible: dailySummaryChecked,
    span: 7,
    fieldAlert: isSubmitted ? false : errorKeys?.startTime,
    allowClear: true,
    disabled: isSubmitted,
    allowTyping: true,
  },
  {
    type: InputfieldTypes.TIME_PICKER,
    name: fieldConstants.END_TIME_NAME,
    label: fieldConstants.END_TIME_LABEL,
    className: processingInputsConstants.TIME_PICKER_CLASS,
    placeholder: placeholderValues.TIME_PLACEHOLDER,
    visible: dailySummaryChecked,
    span: 7,
    fieldAlert: isSubmitted ? false : errorKeys?.endTime,
    allowClear: true,
    disabled: isSubmitted,
    allowTyping: true,
  },
  {
    type: InputfieldTypes.SELECT,
    name: fieldConstants.TRUCK_NUMBER_NAME,
    label: fieldConstants.TRUCK_NUMBER_LABEL,
    placeholder: placeholderValues.SELECT_PLACEHOLDER,
    visible: true,
    span: 7,
    fieldAlert: isSubmitted ? false : errorKeys?.truckNumber,
    allowClear: true,
    showSearch: true,
    disabled: isSubmitted,
  },
  {
    type: InputfieldTypes.TEXT,
    name: fieldConstants.QUANTITY_NAME,
    label: fieldConstants.QUANTITY_LABEL,
    placeholder: placeholderValues.QUANTITY_PLACEHOLDER,
    visible: !dailySummaryChecked,
    span: 7,
    fieldAlert: isSubmitted
      ? false
      : errorKeys?.quantity || errorKeys?.quantityType,
    allowClear: true,
    disabled: isSubmitted,
  },
  {
    type: InputfieldTypes.TIME_PICKER,
    name: fieldConstants.LOAD_TIME_NAME,
    label: fieldConstants.LOAD_TIME_LABEL,
    className: processingInputsConstants.TIME_PICKER_CLASS,
    placeholder: placeholderValues.TIME_PLACEHOLDER,
    visible: !dailySummaryChecked,
    span: 7,
    fieldAlert: isSubmitted ? false : errorKeys?.loadTime,
    allowClear: true,
    disabled: isSubmitted,
    allowTyping: true,
    customNote: "Enter load time only when it is known exactly",
  },
  {
    type: InputfieldTypes.TEXT,
    name: fieldConstants.LOAD_COUNT_NAME,
    label: fieldConstants.LOAD_COUNT_LABEL,
    placeholder: placeholderValues.COUNT_PLACEHOLDER,
    visible: dailySummaryChecked,
    span: 7,
    fieldAlert: isSubmitted ? false : errorKeys?.loadCount,
    allowClear: true,
    disabled: isSubmitted,
  },
  {
    type: InputfieldTypes.LABEL,
    name: fieldConstants.REVIEW_NOTES_NAME,
    label: fieldConstants.REVIEW_NOTES_LABEL,
    textAreaRows: 4,
    visible: isManagerReview,
    span: 24,
    allowClear: true,
    disabled: true,
  },
];

export const loadCountOptions = Array.from({ length: 20 }, (_, i) => ({
  label: i + 1,
  value: i + 1,
}));

export const DUPLICATE_TICKET_STATUS = {
  NOT_DUPLICATE: "notDuplicate",
  INVOICED_DUPLICATE: "invoicedDuplicate",
  APPROVED_DUPLICATE: "approvedDuplicate",
};
